import React, { useState, useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { useGraphStore } from "../store";

export const FilterPanelFormNavigation = () => {
  const location = useLocation();
  const [currentIndex, setCurrentIndex] = useState(0);
  const [clubParam, setClubParam] = useState(new URLSearchParams(location.search).get('selected_club'));

  const allGraphs = useGraphStore((state) => state.allGraphs);
  const visibleGraphs = allGraphs.filter(graph => !graph.hide);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const selectedGraph = params.get('graph');
    setClubParam(params.get('selected_club'));

    if (selectedGraph) {
      const index = visibleGraphs.findIndex(graph => graph.url === selectedGraph);
      if (index !== -1) {
        setCurrentIndex(index);
      }
    }
  }, [location.search, visibleGraphs]);

  const getPrevIndex = () => {
    let prevIndex = (currentIndex - 1 + visibleGraphs.length) % visibleGraphs.length;
    while (visibleGraphs[prevIndex].hide) {
      prevIndex = (prevIndex - 1 + visibleGraphs.length) % visibleGraphs.length;
    }
    return prevIndex;
  };

  const getNextIndex = () => {
    let nextIndex = (currentIndex + 1) % visibleGraphs.length;
    while (visibleGraphs[nextIndex].hide) {
      nextIndex = (nextIndex + 1) % visibleGraphs.length;
    }
    return nextIndex;
  };

  const prevIndex = getPrevIndex();
  const nextIndex = getNextIndex();

  const handleNavigation = (direction) => {
    if (direction === 'prev') {
      setCurrentIndex(prevIndex);
    } else if (direction === 'next') {
      setCurrentIndex(nextIndex);
    }
  };

  return (
    <div className="filterPanel-footer">
      {/* Previous Button */}
      <NavLink 
        to={`detail?graph=${visibleGraphs[prevIndex].url}${clubParam ? `&selected_club=${clubParam}` : ''}`}
        onClick={() => handleNavigation('prev')}
        className="filterPanel-footer-button previous"
      >
        <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M13.839 10.9808H3.91833V9.815H13.839L9.16979 5.14604L10 4.31833L16.0817 10.4L10 16.4817L9.16979 15.654L13.839 10.9808Z"
            fill="#E8EAED"
          />
        </svg>
        <div className="filterPanel-footer-button-text">{visibleGraphs[prevIndex].title}</div>
      </NavLink>

      {/* Next Button */}
      <NavLink 
        to={`detail?graph=${visibleGraphs[nextIndex].url}${clubParam ? `&selected_club=${clubParam}` : ''}`} 
        onClick={() => handleNavigation('next')}
        className="filterPanel-footer-button next"
      >
        <div className="filterPanel-footer-button-text">{visibleGraphs[nextIndex].title}</div>
        <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M13.839 10.9808H3.91833V9.815H13.839L9.16979 5.14604L10 4.31833L16.0817 10.4L10 16.4817L9.16979 15.654L13.839 10.9808Z"
            fill="#E8EAED"
          />
        </svg>
      </NavLink>
    </div>
  );
};
